import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useMutation } from '@tanstack/react-query';
import { queryUnits } from '../../adapters/unit';
import { IUnit } from '../../interfaces/unit';
import { SizeType } from 'antd/es/config-provider/SizeContext';

interface IProps {
  value?: string;
  size?: SizeType;
  isAll?: boolean;
  handleSelectData: (id: string) => void;
}

const UnitSelector = ({
  value,
  size = 'large',
  handleSelectData,
  isAll = false,
}: IProps) => {
  const [group, setUnit] = useState<IUnit[]>([]);
  const mutations = useMutation({
    mutationFn: async () => await queryUnits(),
    mutationKey: ['fetchUnit'],
    onSuccess: data => {
      if (data?.status != 200) {
        throw new Error();
      } else {
        setUnit(data.data);
      }
    },
    onError: error => {
      console.log(error);
    },
  });

  const fetchUnit = async () => {
    try {
      mutations.mutateAsync();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchUnit();
  }, []);

  const groupOptions =
    group?.map(g => {
      return {
        value: g.name,
        label: g.name,
      };
    }) || [];

  const allOptions = [{ value: '', label: 'ทั้งหมด' }, ...groupOptions];

  return (
    <Select
      value={value}
      className="md:min-w-[150px]"
      size={size}
      placeholder="เลือกหน่วย"
      onChange={handleSelectData}
      options={isAll ? allOptions : [...groupOptions]}
    />
  );
};

export default UnitSelector;
